import { render, staticRenderFns } from "./Proportion_fishery.vue?vue&type=template&id=19d405b8&scoped=true"
import script from "./Proportion_fishery.vue?vue&type=script&lang=js"
export * from "./Proportion_fishery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d405b8",
  null
  
)

export default component.exports